<template>
  <add-record
    :title="((companyName) ? 'Add' : 'New') + ' Quote'"
    :pageInfo="localPageInfo"
    :modalId="'add-quotes-modal'"
    :fields="fields"
    :gridId="gridId"
    :onSuggestNameChange="onSuggestNameChange"
    :onSuggestNameSelect="onSuggestNameSelect"
    :getListOfNames="getListOfNames"
    :suggestionList="customerList"
    :resetModal="clearModal"
    :saveRecord="addQuote"
    :items="itemData"
    :sortMethod="onGetData"
    :showFilters="showFilters"
    :contactsArr="contacts"
    :filterValObj="filterValObj"
    :getDataMethod="onGetData"
    :isCompanyNameDefined="companyName != undefined"
    @addItemClick="onShowModal"
    @updateCheckedRowItemIds="checkedReqs = $event"
    class="mr-2">
    <template v-slot:headerSlot>
      <h6>{{ !companyId ? 'Please find your customer and then select' : ' Select' }} any open requirements from the grid below, or "Add" a new Quote.</h6>
    </template>
  </add-record>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import AddRecord from '@/shared/components/AddRecord';

import { AUTO_COMPLETE_STYLES, CUSTOMER_ID } from '@/shared/constants';
import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';

import requirementLineFields from '@/pages/Requirements/fields';

export default {
  components: {
    AddRecord
  },
  computed: {
    ...mapGetters('quoteAdd', ['contacts']),
    ...mapGetters('requirements', ['gridList', 'pageInfo']),
    ...mapGetters('account', ['gridSettingsById']),
    gridId: function() {
      return GRID_ID.REQUIREMENT_FOR_QUOTE;
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      return this.gridList || [];
    }
  },
  data() {
    return {
      prepareColumnsData,
      filterValObj: {
        id: 0,
        companyId: this.companyId || null,
        accountId: this.companyId || null,
        companyName: null
      },

      customerNameTouched: false,
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      selectedAccount: {},
      fields: requirementLineFields,
      isLoading: false,
      showFilters: {
        customer: true,
        contact: true
      },
      checkedReqs: [],
      customerList: [],
      localPageInfo: {}
    }
  },
  props: {
    companyId: [Number, String],
    companyName: [String],
  },
  methods: {
    ...mapActions('quoteAdd', [
      'getContacts',
      'createQuote',
    ]),
    ...mapActions('requirements', ['search', 'sortGrid', 'getAll']),
    ...mapMutations('quoteAdd', {quoteAddSetItem: 'setItem'}),
    ...mapMutations('requirements', {requirementSetItem: 'setItem'}),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('companies', ['getByNameAndAccountType']),
    ...mapActions('quotes', ['addFromRequirement']),
    showModal() {
      this.$bvModal.show('add-quote-modal');
    },
    addQuote: async function(e) {
      if (!this.filterValObj.companyId) {
        alert('Please provide company name');
        return;
      }

      const { id } = await this.createQuote(this.filterValObj);

      for(let i in this.checkedReqs) {
        const qLine = await this.addFromRequirement({
          quoteId: id,
          requirementLineId: this.checkedReqs[i]
        });
      }    

      this.clearModal();

      this.$router.push({ name: 'quotes.edit', params: { id }});
    },
    async getListOfNames(name) {
      this.customerList = await this.getByNameAndAccountType({
        typeId: CUSTOMER_ID, name});

      return this.customerList;
    },
    async onSuggestNameSelect(suggestion) {
      this.selectedAccount = suggestion;
      this.filterValObj.accountId = suggestion.id;
      this.filterValObj.companyId = suggestion.id;
      this.filterValObj.companyName = suggestion.name
      this.getContacts(suggestion.id);
      this.onGetData({ ...this.localPageInfo,  pageNumber: 1 });
    },
    async onGetData(params) {
      // this.requirementSetItem({ resource: 'pageInfo', payload: { ...this.pageInfo, ...params }});
      if (this.filterValObj.accountId) {
        const results = await this.getAll({
          ...params,
          filters: {
            companyId: this.filterValObj.accountId,
            isOpen: true
          },
          isSavePageInfo: false,
        });
        this.localPageInfo = { ...this.localPageInfo, ...results.paging };
      }
    },
    async onSuggestNameChange(val) {
      if(val === '') {
        this.clearModal();
      }
    },
    async clearModal() {
      if (!this.companyId && !this.companyName) {
        this.filterValObj.accountId = null;
        this.filterValObj.companyId = null;
        this.requirementSetItem({ resource: 'gridList', payload: [] });
        this.quoteAddSetItem({ resource: 'contacts', payload: [] });
      }
    },
    onShowModal() {
      let companyId= parseInt(this.companyId);
      if (this.filterValObj.accountId != companyId) {
        this.onSuggestNameSelect({
          id: companyId,
          name: this.companyName
        });  
      } if (this.filterValObj.companyName != this.companyName) {
        this.filterValObj.companyName = this.companyName;
      } if (this.contacts.length == 0) {
        this.getContacts(companyId);
      } else if (this.itemData.length == 0) {
        this.onGetData({ ...this.localPageInfo,  pageNumber: 1 });
      }
    }
  },
  mounted() {
    this.requirementSetItem({ resource:'gridList', payload: [] });
    this.localPageInfo = { ...this.gridSettings.sort, ...this.gridSettings.pageSize }

    // if (this.companyId && this.companyName) {
    //   this.onSuggestNameSelect({
    //     id: parseInt(this.companyId),
    //     name: this.companyName
    //   });
    // }
  }
};
</script>
